<template>
    <b-modal id="createModal" ref="modal" title="Create a Country" v-model="show" @ok="handleSubmit" @hide="close" @shown="focusNameInput">

        <div class="form-group">
            <label>Package Name</label>
            <div class="position-relative">
                <input type="text" ref="nameInput" name="name" v-validate="{required: true}" class="form-control" v-model="name">
                <div class="invalid-feedback" v-if="errors.has('name')">{{ errors.first('name') }}</div>
                <i class="form-group__bar"></i>
            </div>
        </div>

        <div class="form-group">
            <label>Package Description</label>
            <div class="position-relative">
                <textarea class="form-control" v-model="description" placeholder="Description..." v-autosize></textarea>
                <div class="invalid-feedback" v-if="errors.has('description')">{{ errors.first('description') }}</div>
                <i class="form-group__bar"></i>
            </div>
        </div>

        <div class="form-group">
            <label>Package Price ($/month)</label>
            <div class="position-relative">
                <VueMask v-model.number="price" class="form-control"
                         :class="{'is-invalid': errors.has('price')}"
                         placeholder="0..."
                         v-validate="validation.price"
                         data-vv-name="price"
                         data-vv-as="price"
                         :options="{numeral: true, numeralPositiveOnly: true}" />
                <div class="invalid-feedback" v-if="errors.has('price')">{{ errors.first('price') }}</div>
                <i class="form-group__bar"></i>
            </div>
        </div>

        <div class="form-group">
            <label>Package Features</label>
            <div class="position-relative">
                <div class="custom-control custom-checkbox py-1" v-for="feature in features">
                    <input type="checkbox" class="custom-control-input"
                           :checked="selectedFeatures.includes(feature.id)"
                           @click.prevent="toggleFeature(feature.id)"
                           :id="`feature_${feature.id}`">
                    <label class="custom-control-label" :for="`feature_${feature.id}`">{{ feature.title }}</label>
                </div>
            </div>
        </div>

        <template slot="modal-footer">
            <button class="btn btn-secondary" @click="close">
                Cancel
            </button>
            <button class="btn btn-primary" :disabled="okDisabled" @click="handleSubmit">
                Save
            </button>
        </template>
    </b-modal>
</template>


<script>
import listPackageQuery from '@views/Packages/Browse/queryListPackages.graphql';
import createPackageMutation from '@views/Packages/CreateModal/mutationCreatePackage.graphql';
import listFeaturesQuery from '@views/Packages/CreateModal/queryListFeatures.graphql';

export default {
  name: 'create-modal',
  apollo: {
    features: {
      query: listFeaturesQuery,
      update: data => data.filterFeatures,
    },
  },
  props: {
    close: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      features: [],
      name: '',
      description: '',
      selectedFeatures: [],
      price: null,
      show: true,
      loading: 0,
      validation: {
        name: { required: true },
        price: { required: true },
      },
    };
  },
  computed: {
    okDisabled() {
      return this.name.length === 0;
    },
  },
  methods: {
    toggleFeature(featureId) {
      if (this.selectedFeatures.includes(featureId)) {
        this.selectedFeatures = this.selectedFeatures.filter(id => id !== featureId);
      } else {
        this.selectedFeatures = [...this.selectedFeatures, featureId];
      }
    },

    handleSubmit() {
      if (this.okDisabled) {
        return false;
      }
      this.errors.remove('global');
      this.$validator.validateAll().then(validationWasSuccessful => {
        if (!validationWasSuccessful) {
          return;
        }

        const input = { name: this.name };

        this.$apollo
          .mutate({
            mutation: createPackageMutation,
            refetchQueries: [
              { query: listPackageQuery, variables: { input: { include_deleted: true } } },
              { query: listPackageQuery },
            ],
            variables: {
              input: {
                name: this.name,
                description: this.description,
                price: this.price,
                features: this.selectedFeatures,
              },
            },
          })
          .then(() => {
            this.$notifySuccess('Package created!');
            this.close();
          })
          .catch(err => this.$mapGraphQLError(err))
          .catch(err => {
            console.error(err);
            this.$notifyFailure('Unfortunately, we were unable to do that!');
          });
      });
    },
    focusNameInput() {
      this.$refs.nameInput.focus();
    },
  },
};
</script>
